// Generated by packages/browser-pyright/build.js. Do not edit.
export const pyrightManifest = {
    version: "1.1.400",
    workerFile: "pyright.v1.1.400.48ebc1d286c2886d6c80.worker.js",
};
